import { useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";

export const useTour = (tourSteps = []) => {
  const location = useLocation();
  const navigate = useNavigate();

  const [stepIndex, setStepIndex] = useState(0);

  const steps = tourSteps.filter((step) => step.route === location.pathname);

  const handleRouteChange = (data) => {
    const { index, type, action } = data;

    if (type === "step:after") {

      // NEXT BUTTON
      if (action === "next") {
        const nextStep = tourSteps[index + 1];

        if (nextStep?.route && nextStep.route !== location.pathname) {
          navigate(nextStep.route);
        }

        setStepIndex(index + 1);
      }

      // BACK BUTTON
      if (action === "prev") {
        const prevStep = tourSteps[index - 1];

        if (prevStep?.route && prevStep.route !== location.pathname) {
          navigate(prevStep.route);
        }

        setStepIndex(index - 1);
      }
    }
  };

  return {
    steps,
    stepIndex,
    handleRouteChange,
  };
};